module.exports = __webpack_public_path__ + "img/post-play-thumb.d98ffe7f.jpg";